import {Link, Navigate, useLocation, useNavigate} from "react-router-dom";
import React, { useEffect, useState, useRef } from "react";
import { useForm } from "react-hook-form";
import {Oval} from "react-loader-spinner";
import AuthApi from '~/api/authApi';

const apiUrl = process.env.REACT_APP_API_URL;

function ConfirmEmail() {
    const [valid, setValid] = useState(false);
    const [disabled, setDisabled] = useState(false);
    const [error, setError] = useState(null);
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const email = queryParams.get("Email");
    const token = queryParams.get("Token");
    const inputsRef = useRef([]);
    const navigate = useNavigate();

    if(!email || !token) {
        navigate(`/auth/signin`, { replace: true });
    }
    const { register, setValue, getValues, watch, handleSubmit } = useForm({
        defaultValues: {
            code0: "",
            code1: "",
            code2: "",
            code3: "",
            code4: "",
            code5: "",
        },
    });

    const codeValues = watch(["code0", "code1", "code2", "code3", "code4", "code5"]);
    const isComplete = codeValues.every((v) => /^\d$/.test(v));


    useEffect(() => {
        AuthApi.verifyTempToken({
            Email: email,
            Token: token
        }).then(res => {
            if(res.data?.Succeeded){
                setValid(true);
            }
            else{
                navigate(`/auth/failed?token=${token}`, { replace: true });
            }
        }).catch(error => {
            console.error(error);
        })
    }, []);

    const handleInput = (e, index) => {
        const value = e.target.value;
        if (/^\d$/.test(value)) {
            setValue(`code${index}`, value);
            if (index < 5) inputsRef.current[index + 1].focus();
        } else {
            setValue(`code${index}`, "");
        }
    };

    const handleBeforeInput = (e) => {
        if (!/^\d$/.test(e.data)) {
            e.preventDefault();
        }
    };

    const handleKeyDown = (e, index) => {
        if (e.key === "Backspace") {
            const currentValue = getValues(`code${index}`);
            if (!currentValue && index > 0) {
                setValue(`code${index - 1}`, "");
                inputsRef.current[index - 1].focus();
            } else {
                setValue(`code${index}`, "");
            }
        }
    };

    const onSubmit = () => {
        const code = codeValues.join("");
        setDisabled(true);
        AuthApi.emailConfirmCode({
            Email: email,
            Code: code
        })
        .then(res => {
            if(res.data?.Succeeded){
                navigate(`/auth/confirm-email/success?token=${token}`, { replace: true });
            }
            else{
                setError(res.data?.Message);
            }
        })
        .catch(error => {
            console.error(error);
        })
        .finally(() => {
            setDisabled(false);
        })
    };

    return (
        <div className="px-xxl-5">
            {
                !valid && (
                    <div className="text-center mb-1 d-flex align-items-center flex-column">
                        <Oval
                            height="30"
                            width="30"
                            color="#2f5aa2"
                            ariaLabel="oval-loading"
                        />
                        <span className="text-primary fs-9 mt-2 fw-bold">Verifying your session...</span>
                    </div>
                )
            }
            {
                valid && (
                    <div className="text-center mb-6">
                        <h4 className="text-body-highlight">Enter the verification code</h4>
                        <p className="text-body-tertiary mb-0 mt-3 fs-8-1 mb-3">
                            An email containing a 6-digit verification code has been sent to the
                            email address - <strong>{email} </strong>
                        </p>
                        {
                            error && (
                                <span className="text-danger fs-8-1">{error}</span>
                            )
                        }
                        <div className="verification-form mt-1">
                            <form onSubmit={handleSubmit(onSubmit)}>
                                <div className="d-flex align-items-center gap-2 mb-3">
                                    {[...Array(6)].map((_, i) => (
                                        <input
                                            key={i}
                                            type="text"
                                            maxLength={1}
                                            className="px-2 text-center form-control"
                                            {...register(`code${i}`)}
                                            ref={(el) => (inputsRef.current[i] = el)}
                                            onBeforeInput={handleBeforeInput}
                                            onChange={(e) => handleInput(e, i)}
                                            onKeyDown={(e) => handleKeyDown(e, i)}
                                        />
                                    ))}
                                </div>
                                <button
                                    type="submit"
                                    className="w-100 mb-5 btn btn-primary"
                                    disabled={!isComplete || disabled}
                                >
                                    {
                                        disabled && (
                                            <span role="status" aria-hidden="true" className="spinner-border spinner-border-sm me-3"></span>
                                        )
                                    }
                                    Verify
                                </button>
                                <Link className="fs-9 fw-bold" to="#" data-discover="true">
                                    Didn’t receive the code?
                                </Link>
                            </form>
                        </div>
                    </div>
                )
            }
        </div>
    );
}

export default ConfirmEmail;
